export default __webpack_public_path__ + "static/ready-set-relax-8-ways-you-can-actually-relax-on-holiday-stress-less-c468555928f771d4059133180a27e6f4.jpg";